import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20artistic%20background%20illustration%2C%20warm%20coral%20and%20cream%20ambient%20lighting%2C%20soft%20gradient%20atmosphere%2C%20abstract%20comic%20style%20elements%2C%20elegant%20minimalist%20design%2C%20warm%20golden%20hour%20tone%2C%20subtle%20depth%20of%20field%2C%20dreamy%20reading%20mood&width=1800&height=800&seq=manhwa-hero-bg&orientation=landscape"
        alt="韩漫屋 - 免费韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-5 tracking-wide">
            {siteInfo.tagline}
          </h1>
          <p className="text-background-50/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
            {siteInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-sm"
            >
              探索漫画
              <i className="ri-arrow-right-up-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-7 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 font-medium rounded-full hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer text-sm border border-background-50/25"
            >
              了解更多
              <i className="ri-information-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-6 text-background-50/70 text-sm">
          <div className="flex items-center gap-1.5">
            <span className="font-heading text-2xl text-primary-400">5000+</span>
            <span>漫画资源</span>
          </div>
          <div className="w-px h-4 bg-background-50/30"></div>
          <div className="flex items-center gap-1.5">
            <span className="font-heading text-2xl text-accent-400">100万+</span>
            <span>日活读者</span>
          </div>
          <div className="w-px h-4 bg-background-50/30"></div>
          <div className="flex items-center gap-1.5">
            <span className="font-heading text-2xl text-primary-400">每日更新</span>
          </div>
        </div>
      </div>
    </section>
  );
}